import { render, staticRenderFns } from "./exemptionUnderSectionSeventeen.vue?vue&type=template&id=394364f3&scoped=true"
import script from "./exemptionUnderSectionSeventeen.vue?vue&type=script&lang=js"
export * from "./exemptionUnderSectionSeventeen.vue?vue&type=script&lang=js"
import style0 from "./exemptionUnderSectionSeventeen.vue?vue&type=style&index=0&id=394364f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394364f3",
  null
  
)

export default component.exports